import { render, staticRenderFns } from "./RoomCta.vue?vue&type=template&id=13543336"
import script from "./RoomCta.vue?vue&type=script&lang=ts"
export * from "./RoomCta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports